// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('checkListItemTw', {
//         templateUrl: 'views/components/views/checkListItemTw/checkListItemTw.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'checkListItemTwService', function ($stateParams, stateService, utilityService, translateService, modalService, checkListItemTwService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let argType = $stateParams.argtype;
//             let argValue = $stateParams.argvalue;
//             let checkListItemTwKeyno = $stateParams.checklistitemtw_keyno;

//             let translations = {
//                 confirm_title: '',
//                 confirm_message: '',
//                 confirm_ok_label: '',
//                 confirm_cancel_label: '',
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 checkListItemTwKeyno: checkListItemTwKeyno,
//                 edit: {},
//                 selectListLinksToForms: [],
//                 selectListCheckListItems: [],
//                 lockedSave: false,
//                 lockedDelete: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTIONS

//             async function loadEdit() {
//                 vm.model.edit = (await checkListItemTwService.getEdit({
//                     argtype: argType,
//                     argvalue: argValue,
//                     checklistitemtw_keyno: checkListItemTwKeyno
//                 }))[0];
//             }

//             async function loadCheckLists() {
//                 vm.model.selectListLinksToForms = await checkListItemTwService.listCheckLists();
//             }
            
//             async function loadCheckListItems() {
//                 if (utilityService.validateParmsValue(vm.model.edit.checklist_keyno) !== true) return;
                
//                 return vm.model.selectListCheckListItems = await checkListItemTwService.listCheckListItems({ checklist_keyno: vm.model.edit.checklist_keyno });
//             }

//             // #endregion LOAD PROCEDURE FUNCTIONS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 checkListItemTwService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//             vm.deleteValues = function () {
//                 vm.model.lockedDelete = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     checkListItemTwService.deleteItem(vm.model.edit).then(function (response) {
//                         if (response[0].errorcode !== '0') {
//                         	modalService.show({
//                         		type: 'warning',
//                         		title: translations.error,
//                         		message: response[0].errormessage,
//                         		buttons: [{
//                         			label: translations.ok,
//                         			cssClass: 'btn-warning',
//                         			action: function (dialogItself) {
//                         				dialogItself.close();
//                         				vm.model.lockedDelete = false;
//                         			}
//                         		}]
//                         	});
//                         } else {
//                         	vm.model.lockedDelete = false;
//                         	stateService.back();
//                         }
//                     }, function () {
//                         vm.model.lockedDelete = false;
//                     });
//                 }, function () {
//                     vm.model.lockedDelete = false;
//                 });
//             }

//             // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//             // #region ON CHANGE FUNCTION

//             vm.onChecklistKeynoChanged = function (value) {
//                 vm.model.edit.checklist_keyno = value;

//                 if (value) loadCheckListItems();
//             }

//             // #endregion ON CHANGE FUNCTION

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadCheckLists();
//                 loadCheckListItems();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
